import { Alert, AppBar, Box, Container, IconButton, Toolbar, Typography } from "@mui/material";
import {
    Add as AddIcon,
    Code as CodeIcon,
    Logout as LogoutIcon,
    Search as SearchIcon,
  } from '@mui/icons-material';
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import TryCodingPanel from "./TryCodingPanel";

export default function CustomAppBar({ children }) {
    const { user, logout } = useAuth();
    const [tryCodingOpen, setTryCodingOpen] = useState(false);

    const handleLogout = () => {
        logout();
      };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
            <AppBar position="static" elevation={0} sx={{ borderRadius: 0 }}>
                <Toolbar sx={{ px: { xs: 2, md: 4 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <CodeIcon sx={{ mr: 2, fontSize: 28 }} />
                        <Typography variant="h5" component="div" sx={{ fontWeight: 700, letterSpacing: '-0.5px' }}>
                            The Revision App
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1, bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 2 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                Welcome, {user?.username}!
                            </Typography>
                        </Box>
                        <IconButton
                            color="inherit"
                            onClick={() => setTryCodingOpen(true)}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                            }}
                        >
                            <CodeIcon />
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={handleLogout}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                            }}
                        >
                            <LogoutIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Container maxWidth="xl" sx={{ flexGrow: 1, py: 4, px: { xs: 2, md: 4 } }}>
                {children}
            </Container>

            {/* Try Coding Panel */}
            <TryCodingPanel
                open={tryCodingOpen}
                onClose={() => setTryCodingOpen(false)}
            />
        </Box>
    )
}